<template>
    <div class="c-app">
        <div v-if="bool_showNotif">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCol>
                            <CCard>
                                <CCardBody>
                                    <CRow>
                                        <CCol col="10">
                                            <h6 id="traffic" class="card-title mb-0">{{ obj_notif['T'] }}</h6>
                                        </CCol>
                                        <CCol col="2">
                                            <CButton id="btn-close1" class="float-right" @click="closeNotif()">
                                                <CIcon name=cilX></CIcon>
                                            </CButton>
                                        </CCol>
                                    </CRow>
                                    <div class='subHeaderHR'></div>
                                    <CRow>
                                        <!--<CCol col="12">{{ //obj_notif['CBD'] }}</CCol>-->
                                        <CCol col="12" v-html="obj_notif['CBD']"></CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="12">
                                            <small class="text-muted float-right">{{ FormatNotifTime(obj_notif['CTS']) }}</small>
                                        </CCol>
                                    </CRow>
                                </CCardBody>
                            </CCard>
                        </CCol>
                    </div>
                </div>
            </transition>
        </div>

        <SideMenuBar />
        <!--<div class='sound-file'>
        <audio id="DepositAudio" src="../../src/assets/sound/deposit.mp3"></audio>
        <audio id="3rdPartyDepositAudio" src="../../src/assets/sound/3rdpartydeposit.mp3"></audio>
    </div>-->
        <div class="c-wrapper">
            <Header />
            <div class="c-body">
                <main class="c-main pt-0">
                    <transition name="fade">
                        <router-view :arry_san_length.sync="arry_san_length" style=" padding-bottom: 60px; "></router-view>
                    </transition>
                </main>
            </div>
            <!--<TheFooter/>-->
        </div>
        <!--<notifications group="msgNotification" position="bottom right" :max="1" :width="350">
        <template slot="body" slot-scope="props">
            <div :class="['custom-template', props.item.type]">
                <div class="custom-template-content">
                    <div class="custom-template-title">{{props.item.title}}</div>
                    <div class="custom-template-text" v-html="props.item.text"></div>
                </div>
                <div class="custom-template-close" @click="props.close">
                    <i class="icon ion-android-close">&times;</i>
                </div>
            </div>
        </template>
    </notifications>
    <notifications group="msgNotificationTop" position="top left" :max="1" :width="350">
        <template slot="body" slot-scope="props">
            <div :class="['custom-template', props.item.type]">
                <div class="custom-template-content">
                    <div class="custom-template-title">{{props.item.title}}</div>
                    <div class="custom-template-text" v-html="props.item.text"></div>
                </div>
                <div class="custom-template-close" @click="props.close">
                    <i class="icon ion-android-close">&times;</i>
                </div>
            </div>
        </template>
    </notifications>-->

    <CRow class="bottomNav">
        <CCol col="auto">
            <router-link to="/DASH/DBM" tag="a">
                <!--<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_26_7541)">
                        <path d="M1.5 9.15292C1.5 7.43662 1.5 6.57846 1.8894 5.86705C2.2788 5.15566 2.99021 4.71413 4.41302 3.8311L5.91302 2.90015C7.41704 1.96672 8.16907 1.5 9 1.5C9.83092 1.5 10.5829 1.96672 12.087 2.90015L13.587 3.83109C15.0098 4.71413 15.7212 5.15566 16.1106 5.86705C16.5 6.57846 16.5 7.43662 16.5 9.15292V10.2937C16.5 13.2193 16.5 14.6822 15.6213 15.5911C14.7427 16.5 13.3284 16.5 10.5 16.5H7.5C4.67157 16.5 3.25736 16.5 2.37868 15.5911C1.5 14.6822 1.5 13.2193 1.5 10.2937V9.15292Z" stroke="#FF7500" stroke-width="1.5" />
                        <path d="M11.25 13.5H6.75" stroke="#FF7500" stroke-width="1.5" stroke-linecap="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_26_7541">
                            <rect width="18" height="18" fill="white" />
                        </clipPath>
                    </defs>
                </svg>-->

                <img class="img-fluid" width="20" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/home.svg" style="filter: drop-shadow(0px 1px 1px black);">
            </router-link>
        </CCol>
        <CCol col="auto">
            <router-link :to="{ path:'/W/WDU', query:{ t: 2 }}" tag="a">
                <!--<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_26_7532)">
                        <path d="M7.56748 12.5791H9.35998C9.64442 12.5791 9.91721 12.4661 10.1183 12.2649C10.3195 12.0638 10.4325 11.791 10.4325 11.5066C10.4325 11.2221 10.3195 10.9493 10.1183 10.7482C9.91721 10.5471 9.64442 10.4341 9.35998 10.4341H8.60998C8.32553 10.4341 8.05274 10.3211 7.8516 10.1199C7.65047 9.9188 7.53748 9.64601 7.53748 9.36156C7.53748 9.07712 7.65047 8.80432 7.8516 8.60319C8.05274 8.40206 8.32553 8.28906 8.60998 8.28906H10.4025" stroke="#FF7500" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square" />
                        <path d="M9 6.85156V8.28406" stroke="#FF7500" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square" />
                        <path d="M9 12.5781V14.0106" stroke="#FF7500" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square" />
                        <path d="M16.875 1.125V8.28H13.2975V4.7025H4.7025V8.28H1.125V1.125H16.875Z" stroke="#FF7500" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square" />
                        <path d="M4.70251 4.70312H13.2975" stroke="#FF7500" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square" />
                        <path d="M13.29 4.70312H4.70251V16.8756H13.29V4.70312Z" stroke="#FF7500" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square" />
                        <path d="M3.27002 4.70312H14.73" stroke="#FF7500" stroke-width="1.5" stroke-miterlimit="10" />
                    </g>
                    <defs>
                        <clipPath id="clip0_26_7532">
                            <rect width="18" height="18" fill="white" />
                        </clipPath>
                    </defs>
                </svg>-->

                <img class="img-fluid" width="20" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/withdraw.svg" style="filter: drop-shadow(0px 1px 1px black);">
            </router-link>
        </CCol>

        <CCol col="auto">
            <router-link :to="{ path:'/EARN/D', query:{ t: 3 }}" tag="a">
                <!--<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_26_7510)">
                        <path d="M1.5 8.25H8.25V1.5H1.5V8.25ZM3 3H6.75V6.75H3V3Z" fill="#FF7500" />
                        <path d="M1.5 16.5H8.25V9.75H1.5V16.5ZM3 11.25H6.75V15H3V11.25Z" fill="#FF7500" />
                        <path d="M9.75 1.5V8.25H16.5V1.5H9.75ZM15 6.75H11.25V3H15V6.75Z" fill="#FF7500" />
                        <path d="M5.625 4.125H4.125V5.625H5.625V4.125Z" fill="#FF7500" />
                        <path d="M11.25 12.375H9.75V16.5H16.5V15H11.25V12.375Z" fill="#FF7500" />
                        <path d="M15 12.375H12.375V13.875H16.5V9.75H15V12.375Z" fill="#FF7500" />
                        <path d="M13.875 9.75H9.75V11.25H13.875V9.75Z" fill="#FF7500" />
                    </g>
                    <defs>
                        <clipPath id="clip0_26_7510">
                            <rect width="18" height="18" fill="white" />
                        </clipPath>
                    </defs>
                </svg>-->

                <img class="img-fluid" width="20" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/ggeran_downile.svg" style="filter: drop-shadow(0px 1px 1px black);">
            </router-link>
        </CCol>

        <CCol col="auto">
            <router-link :to="{ path:'/EARN/D', query:{ t: 2 }}" tag="a">
                <!--<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path opacity="1" d="M8.99999 18C8.61565 17.9994 8.23755 17.9028 7.89999 17.719L1.42199 14.188C1.17898 14.0561 0.976069 13.8611 0.834677 13.6235C0.693286 13.3859 0.618652 13.1145 0.618652 12.838C0.618652 12.5615 0.693286 12.2901 0.834677 12.0525C0.976069 11.8149 1.17898 11.6199 1.42199 11.488L2.46999 10.916L1.42199 10.348C1.17898 10.2161 0.976069 10.0211 0.834677 9.78348C0.693286 9.54587 0.618652 9.2745 0.618652 8.99801C0.618652 8.72151 0.693286 8.45015 0.834677 8.21254C0.976069 7.97493 1.17898 7.77989 1.42199 7.64801L2.46999 7.08001L1.42199 6.50901C1.17898 6.37712 0.976069 6.18209 0.834677 5.94448C0.693286 5.70687 0.618652 5.4355 0.618652 5.15901C0.618652 4.88251 0.693286 4.61115 0.834677 4.37354C0.976069 4.13593 1.17898 3.9409 1.42199 3.80901L7.89699 0.282009C8.23536 0.0969763 8.61483 0 9.00049 0C9.38615 0 9.76562 0.0969763 10.104 0.282009L16.578 3.81301C16.821 3.9449 17.0239 4.13993 17.1653 4.37754C17.3067 4.61515 17.3813 4.88652 17.3813 5.16301C17.3813 5.4395 17.3067 5.71087 17.1653 5.94848C17.0239 6.18609 16.821 6.38112 16.578 6.51301L15.531 7.08401L16.578 7.65601C16.821 7.7879 17.0239 7.98293 17.1653 8.22054C17.3067 8.45815 17.3813 8.72951 17.3813 9.00601C17.3813 9.2825 17.3067 9.55387 17.1653 9.79148C17.0239 10.0291 16.821 10.2241 16.578 10.356L15.531 10.927L16.578 11.499C16.821 11.6309 17.0239 11.8259 17.1653 12.0635C17.3067 12.3011 17.3813 12.5725 17.3813 12.849C17.3813 13.1255 17.3067 13.3969 17.1653 13.6345C17.0239 13.8721 16.821 14.0671 16.578 14.199L10.103 17.718C9.76456 17.9024 9.38541 17.9994 8.99999 18ZM4.07299 11.794L2.15699 12.839L8.63199 16.371C8.74471 16.4325 8.87107 16.4648 8.99949 16.4648C9.12791 16.4648 9.25427 16.4325 9.36699 16.371L15.843 12.839L13.922 11.794L10.103 13.88C9.76462 14.065 9.38515 14.162 8.99949 14.162C8.61383 14.162 8.23436 14.065 7.89599 13.88L4.07299 11.794ZM4.07299 7.95601L2.15699 9.00001L8.63199 12.532C8.74471 12.5935 8.87107 12.6258 8.99949 12.6258C9.12791 12.6258 9.25427 12.5935 9.36699 12.532L15.843 9.00001L13.922 7.95501L10.103 10.04C9.76462 10.225 9.38515 10.322 8.99949 10.322C8.61383 10.322 8.23436 10.225 7.89599 10.04L4.07299 7.95601ZM8.99999 1.53601C8.8714 1.53616 8.7449 1.56848 8.63199 1.63001L2.15699 5.16101L8.63199 8.69301C8.74471 8.75454 8.87107 8.78678 8.99949 8.78678C9.12791 8.78678 9.25427 8.75454 9.36699 8.69301L15.843 5.16101L9.36699 1.62901C9.25444 1.56748 9.12826 1.53516 8.99999 1.53501V1.53601Z" fill="#FF7500" />
                </svg>-->

                <img class="img-fluid" width="20" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/profitloss.svg" style="filter: drop-shadow(0px 1px 1px black);">
            </router-link>
        </CCol>

        <CCol col="auto">
            <router-link to="/S/S" tag="a">
                <!--<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.6748 5.39999C12.6748 3.41459 11.0267 1.79999 9.00001 1.79999C6.97335 1.79999 5.3252 3.41459 5.3252 5.39999C5.3252 7.3854 6.97335 8.99999 9.00001 8.99999C11.0267 8.99999 12.6748 7.3854 12.6748 5.39999ZM16.1512 18H14.5122C14.0051 18 13.5935 17.5968 13.5935 17.1C13.5935 16.6032 14.0051 16.2 14.5122 16.2H14.9063C15.5421 16.2 16.0116 15.5727 15.7709 14.9958C14.6583 12.3282 12.0455 10.8 9.00001 10.8C5.95451 10.8 3.34171 12.3282 2.22917 14.9958C1.98847 15.5727 2.45794 16.2 3.09368 16.2H3.48779C3.99491 16.2 4.40649 16.6032 4.40649 17.1C4.40649 17.5968 3.99491 18 3.48779 18H1.84882C0.70044 18 -0.203564 16.9713 0.0398925 15.8724C0.708708 12.8493 2.79693 10.6182 5.54753 9.60566C4.29258 8.61656 3.48779 7.101 3.48779 5.39999C3.48779 2.20409 6.32108 -0.342921 9.66057 0.0377792C12.0804 0.313179 14.085 2.20224 14.4479 4.56294C14.7603 6.59785 13.9105 8.45636 12.4525 9.60566C15.2031 10.6182 17.2913 12.8493 17.9601 15.8724C18.2036 16.9713 17.2996 18 16.1512 18ZM11.7561 17.1C11.7561 17.5968 11.3445 18 10.8374 18H7.1626C6.65548 18 6.2439 17.5968 6.2439 17.1C6.2439 16.6032 6.65548 16.2 7.1626 16.2H10.8374C11.3445 16.2 11.7561 16.6032 11.7561 17.1Z" fill="#FF7500" />
        </svg>-->

                <img class="img-fluid" width="20" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/support.svg" style="filter: drop-shadow(0px 1px 1px black);">
            </router-link>
        </CCol>
    </CRow>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import SideMenuBar from "./SideMenu/SideMenuBar";
    //import AgentDashboard from "./SideMenu/AgentSetting/AgentDashboard";
    import Header from "./HeaderDropdown/Header";
    import DateRangePicker from "vue2-daterange-picker";
    //you need to import the CSS manually (in case you want to override it)
    import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
    import Vue from "vue";
    import Vuelidate from "vuelidate";
    import genericHelper from "../modules/GenericHelper.js";
    Vue.use(Vuelidate);
    import moment from "moment";
    import $ from 'jquery'
    import { v4 as uuidv4 } from 'uuid';

    export default {
        mixins: [genericHelper],
        data() {
            return {
                arry_san_length: 0,
                showSubMenu: "-1",
                showSubSubMenu: "-1",
                showActiveMenu: "-1",
                bool_showNotif: false,
                obj_notif: [],
                FisrtMenuItem: "",
                AutoUpdateTO: null,
                CheckWindowActiveUpdateTO: null,
                CheckAccessUpdateTO: null,
                tabId: '',                
            };
        },
        components: {
            SideMenuBar,
            Header,
            DateRangePicker,
            //AgentDashboard
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('DashboardData', [
                'getPendingDeposit',
                'getPendingWithdrawal',
                'getPendingPromotion'
            ]),
            ...mapGetters('UserInfo', ['getUserInfo']),
        },
        beforeRouteLeave(to, from, next) {
            clearTimeout(this.AutoUpdateTO);
            clearTimeout(this.CheckWindowActiveUpdateTO);
            clearTimeout(this.CheckAccessUpdateTO);
            next();
        },        
        mounted() {
            this.DepositAudio = document.getElementById('DepositAudio');
            this.ThirdPartyDepositAudio = document.getElementById('3rdPartyDepositAudio');
            //this.getPendingTransaction();
            //this.getCSMemberOnline();
            //this.getTotalMember();
            this.checkAuth();
            this.checkWindowActive();

            this.AutoUpdate();
            this.CheckAccessUpdate();
            this.CheckWindowActiveUpdate();

            //Generate an unique id for each of the tab
            this.tabId = uuidv4();
            sessionStorage.setItem('tabId', this.tabId);

            //To know which tab is active
            document.addEventListener('visibilitychange', this.handleVisibilityChange);
            
            setTimeout(() => { this.resizeLoadingScreen() }, 500)
            $(document).click(() => { this.resizeLoadingScreen() });

            if (this.getUserInfo.IOL) {
                window.location.href = "/app/logout";
            }
        },
        methods: {
            ...mapActions('DashboardData', [
                'setPendingDeposit',
                'setPendingWithdrawal',
                'setPendingPromotion',
                'setPendingAutoDepositPlus',
                'setMemberOnline',
                'setCSOnline'
            ]),
            closeNotif() {
                this.bool_showNotif = !this.bool_showNotif;
            },
            handleVisibilityChange() {
                if (document.hidden) {
                    // Tab became inactive
                    localStorage.setItem('tabId', this.tabId);
                } else {
                    // Tab became active                  
                    sessionStorage.setItem('tabId', this.tabId);
                }
            },            
            FormatNotifTime(date) {
                return moment(date).fromNow();
            },
            //Here Set The Dropdown Button Color
            acColor(ac) {
                if (ac == 2) {
                    return "success";
                } else {
                    return "dark";
                }
            },
            getDetail(id) {
                var that = this;
                this.getDataApi(`/api/anotif/ga/${id}`,
                    function (d, s) {
                        if (s) {
                            that.obj_notif = d.D;
                            that.bool_showNotif = true;
                        }
                    });
            },
            checkStatus(ac) {
                if (ac == 2) {
                    return true;
                } else {
                    return false;
                }
            },
            checkpendingColor(owner) {
                if (owner == "") {
                    return "dark";
                } else {
                    return "success";
                }
            },
            getPendingTransaction() {
                var that = this;
                //this.getDataApi(`/api/memtrans/gmpt?p=&n=&f[AGI]=`,
                //    function (d, s) {
                //        if (s) {
                //            var tpd = 0;
                //            var tpp = 0;
                //            var tpw = 0;
                //            for (var i = 0; i < d.D.Items.length; i++) {
                //                tpd += d.D.Items[i].TPD;
                //                tpp += d.D.Items[i].TPP;
                //                tpw += d.D.Items[i].TPW;
                //            }
                //            that.setPendingDeposit(tpd);
                //            that.setPendingPromotion(tpp);
                //            that.setPendingWithdrawal(tpw);
                //            if (0 < tpd || 0 < tpp || 0 < tpw) {
                //                that.DepositAudio.play();
                //            }
                //        }
                //    });

                //this.getDataApi(`/api/memtrans/gmptv2`,
                //    function (d, s) {
                //        if (s) {
                //            that.setPendingDeposit(d.TPD);
                //            that.setPendingPromotion(d.TPP);
                //            that.setPendingWithdrawal(d.TPW);
                //            that.setPendingAutoDepositPlus(d.TUADP);
                //            if (0 < d.TPD || 0 < d.TPP || 0 < d.TPW || 0 < d.TUADP) {
                //                that.DepositAudio.play();
                //            }

                //            if (0 < d.TTPPD) {
                //                that.ThirdPartyDepositAudio.play();
                //            }
                //        }
                //    });
            },
            // getCSMemberOnline() {
            //     var that = this;
            //     this.getDataApi(`/api/dc/aomo?p=&n=&f[AGI]=`,
            //         function (d, s) {
            //             if (s) {
            //                 //var ao = 0;
            //                 //var mo = 0;
            //                 //for (var i = 0; i < d.D.Items.length; i++) {
            //                 //    if (d.D.Items[i].ICS == 1) {
            //                 //        ao += d.D.Items[i].TO;
            //                 //    } else {
            //                 //        mo += d.D.Items[i].TO;
            //                 //    }
            //                 //}
            //                 that.setCSOnline(d.Item2);
            //                 that.setMemberOnline(d.Item1);
            //             }
            //         });
            // },
            //getTotalMember() {
            //    var that = this;

            //    this.getDataApi(`/api/dc/totalMember`,
            //        function (d, s) {
            //            if (s) {
            //                that.setTotalMember(d);
            //            }
            //        });
            //},
            AutoUpdate() {
                this.nextUpdate()
                var that = this;
                this.AutoUpdateTO = setTimeout(function () {
                    that.AutoUpdate();
                }, 10000);
            },
            nextUpdate: function () {
                this.getPendingTransaction();
                //this.getCSMemberOnline();
                //this.getTotalMember();
            },
            CheckAccessUpdate() {                
                this.nextCheckAccess(); //check auth token every 30 seconds
                var that = this;
                this.CheckAccessUpdateTO = setTimeout(function () {
                    that.CheckAccessUpdate();
                }, 30000);
            },
            nextCheckAccess: function () {
                this.checkAuth();
            },
            CheckWindowActiveUpdate() {
                this.nextCheckWindowActiveUpdate(); //check windows active every 5 sec
                var that = this;
                this.CheckWindowActiveUpdateTO = setTimeout(function () {
                    that.CheckWindowActiveUpdate();
                }, 30000);
            },
            nextCheckWindowActiveUpdate: function () {
                this.checkWindowActive();
            },
            checkAuth() {
                this.getDataApi(`/App/CheckAuth`, function (d) {
                    if (!d.S) {
                        localStorage.setItem('isMute', 'False');                        
                        window.location.href = "/app/logout?showLogAction=false";
                    }
                });
            },
            checkWindowActive() {                
                if (document.hidden && localStorage.getItem('WADT') != null) { //if user is not active
                    var CurrentDateTime = new Date();
                    var LastActiveDateTime = new Date(localStorage.getItem('WADT'));
                    // var autologoutmin = this.getUserInfo.ICS ? 45 : 15;
                    var autologoutmin = 60;

                    if (moment(LastActiveDateTime).add(autologoutmin, 'm').toDate() <= CurrentDateTime) { //15 min inactive
                        localStorage.setItem('isMute', 'False');                       

                        //Only the last active tab will logout, the inactive tab will not
                        if (sessionStorage.getItem('tabId') === localStorage.getItem('tabId')) {
                            window.location.href = "/app/logout?showLogAction=true";                            
                        }
                        else {
                            //If the last active tab is closed, let the inactive tabs to take the session
                            localStorage.setItem('tabId', this.tabId);                            
                        }
                    }
                }
                else {
                    //reset windowActiveCount
                    localStorage.setItem('WADT', new Date());
                }
            },
            resizeLoadingScreen() {
                const popupExists = document.getElementsByClassName('modal-backdrop').length > 0;

                $(".vld-overlay").css({ 'top': '0px', 'left': '0px' })
                if (!popupExists) {
                    const sidemenuMin = document.getElementsByClassName('c-sidebar-minimized').length > 0;
                    const mgl10 = document.getElementsByClassName('vld-overlay-m10').length > 0;
                    const mgl15 = document.getElementsByClassName('vld-overlay-mgl-15').length > 0;

                    var left = 0;
                    if (mgl10) { left = 10; }
                    else if (mgl15) { left = 15; }

                    if (sidemenuMin) {
                        $(".vld-overlay").css({ 'top': $(".c-header").height() + 'px', 'left': (45 + left) + 'px' })
                    } else {
                        $(".vld-overlay").css({ 'top': $(".c-header").height() + 'px', 'left': ($(".c-sidebar-fixed").width() + left) + 'px' })
                    }
                }
            },
            getSANLength: function (params) {
                this.arry_san_length = params;
            }
        }
    };
</script>





// WEBPACK FOOTER //
// src/componentsGGEarn/Dashboard.vue